import { Record } from 'immutable';

export const INVESTMENT_SYMBOLS_KEY = 'investmentSymbolsStore';

export const mkInvestmentSymbol = Record({
  id: undefined,
  symbol: undefined,
  name: undefined,
  exchange: undefined,
  security: undefined,
});
